import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-44d3e171"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "category"
};
const _hoisted_2 = {
  class: "category__inner"
};
const _hoisted_3 = {
  class: "category__list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "category__list-wrapper"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "category__list-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.category, item => {
    return _openBlock(), _createElementBlock("li", {
      key: item.id,
      class: _normalizeClass(["category__list-item", {
        'category-empty': !item.name
      }])
    }, [_createElementVNode("div", {
      class: "category__list-link",
      onClick: $event => _ctx.$router.push(`/rol-shop/${item.path}`)
    }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
      class: "category__list-img",
      src: item.imgUrl ? _ctx.$route.params.category === item.path ? item.imgPath : item.imgUrl : require('@/img/category/category-7.svg'),
      alt: "picture"
    }, null, 8, _hoisted_6)]), _createElementVNode("p", _hoisted_7, _toDisplayString(item.name ? item.name : "Неизвестно"), 1)], 8, _hoisted_4)], 2);
  }), 128))])])]);
}